import { composeIO } from 'react-compose-io'
import { itemControleComissaoIO } from './ItemControleComissao.IO'
import { ItemControleComissaoView } from './ItemControleComissao.View'

export const ItemControleComissao = composeIO(ItemControleComissaoView, itemControleComissaoIO)
